var _linearGradient, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapanLoto6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.001,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f0b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#e31383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#e21884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#df2688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#db3e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#d45e97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#d0739d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#cb6d97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#bb4f83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#a82a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9b125b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#970a55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#8f0b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#970a55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#99135a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#a02a67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#aa507c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#b3728f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b3728f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#8f0b5d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.995 58.518V35.594l50.115-6.783v36.156z",
    fill: "#fdd100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.262 46.854 3.418-7.405v-3.707l2.497 4.898 2.997-5.459.202 6.143 5.713-2.646-3.47 6.046 5.819 2.401-5.819 2.217 3.33 6.257-5.643-2.857v6.327l-3.023-5.109-2.752 4.557-.21-3.321z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#193c96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.243 56.958-.026.324 4.741-.508-.018-.535s-.131-.053-.429-.394c-.438-.517-.359-1.612-.359-1.612l.07-12.408c.035-.885.473-.99.473-.99s.648-.035 1.017.105c.377.131.587.806.587.806h.377l.403-3.225-8.57-1.341-.929 4.206h.429s.193-.438.973-.745c.412-.158.955-.166 1.463-.07.508.105.71.648.71.648l-.035 14.52c-.096.78-.876 1.218-.876 1.218zm-31.187 2.76v.885l13.346-1.42.797-4.776h-.412s-1.157 1.087-2.077 1.262c-.92.166-3.505.035-3.505.035s-.71-.202-.78-1.122-.07-19.147-.07-19.147.14-.955.648-1.393.684-.543.684-.543v-.228L7.89 31.904v.333s1.157 1.052 1.358 2.278 0 22.442 0 22.442.166 1.052-.237 1.937-.955.824-.955.824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.833 35.182c-4.583 0-8.299 5.275-8.299 11.769 0 6.502 3.715 11.558 8.299 11.558s8.299-5.056 8.299-11.558c0-6.493-3.715-11.769-8.299-11.769zm1.13 19.401c-1.928.088-3.654-3.242-3.856-7.457-.202-4.206 1.201-7.694 3.128-7.79 1.928-.088 3.654 3.242 3.856 7.457s-1.201 7.703-3.128 7.79zm20.716-15.905c-2.936 0-5.319 3.786-5.319 8.763 0 4.986 2.384 9.017 5.319 9.017s5.319-4.04 5.319-9.017c.009-4.986-2.375-8.763-5.319-8.763zm.736 14.608c-1.236.07-2.34-2.489-2.471-5.713s.771-5.897 2.007-5.968 2.34 2.489 2.471 5.713c.123 3.225-.771 5.897-2.007 5.968zm-1.297 14.52h1.192v2.515h-1.192zm2.042 0h1.192v2.515H52.16zm-12.277.85H35.02v-2.48h-1.56v7.002h1.56v-3.295h4.863zm-9.315-2.48h-5.337v7.002h6.906v-7.002h-1.569zm0 5.372h-3.777v-3.742h3.777v3.742zm15.064-1.253-3.637-.237v-1.402l3.637.21zm0-2.454-3.637-.237v-1.393l3.637.21zm1.63-.815v2.857c-.499 1.753-2.147 1.665-2.147 1.665h-3.12v1.63h3.172s1.253-.026 2.445-1.017c1.201-.999 1.218-2.278 1.218-2.278v-2.857h-1.569zm3.26 6.152V71.75s1.989.184 2.83-.202.92-1.314.894-2.077c-.026-.754.202-1.63.202-1.63l1.402-.035s-.333.868-.386 2.077.079 1.691-.841 2.48-1.367.815-1.867.815h-2.235zm13.197-7.002h-5.881s0 .929-1.201 3.707h1.551l1.008-2.48h3.225v.631c0 1.709.149 1.831-1.069 2.962-1.227 1.122-3.9.762-3.9.762v1.428h2.375c1.428 0 3.163-1.428 3.619-2.55s.543-2.603.543-2.603v-1.858h-.272zm7.3 4.723a4.594 4.594 0 0 1-.929-.999c.342-.727.429-1.323.429-1.437v-1.052h.386v-1.227h-5.713v1.227h3.847v.78c0 .386-.123 1.148-1.428 2.313-1.297 1.165-2.83 1.253-2.83 1.253v1.428h1.095s1.209-.245 2.769-1.455a4.767 4.767 0 0 0 .613-.57 4.881 4.881 0 0 0 .946 1.165c.78.692 1.569.85 1.569.85h.386v-1.63c-.018 0-.456-.123-1.139-.648z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m79.527 39.046 4.898-7.992-4.399-1.63-5.617 9.587-.315.815 4.215.342z",
    fill: "#7e0042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m75.811 39.625-1.209-.307s1.279-.578 2.059-.64c.78-.07 5.573.666 5.573.666s3.453.824 5.126 3.786c1.341 2.392 1.507 4.145 1.534 5.678.018 1.157.429 5.661-2.734 8.623s-7.159 3.488-9.893 3.479c-1.718 0-3.987-1.025-3.987-1.025s5.836.929 8.728-4.82c2.874-5.757-.692-14.389-5.196-15.44z",
    fill: "#ab3f73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m84.425 31.054-4.399-1.63-3.777-2.603 4.031 1.647z",
    fill: "#c6006e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.729 54.276c-1.814 0-3.277-2.156-3.277-4.811 0-2.462 1.262-4.487 2.883-4.776-.754-.613-1.639-.981-2.594-.981-2.681 0-4.846 2.795-4.846 6.248s2.164 6.248 4.846 6.248c1.402 0 2.673-.78 3.558-2.015a1.8 1.8 0 0 1-.57.088z",
    fill: "url(#a)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.604 40.589c-2.191-1.884-4.241-1.761-5.1-1.753-1.122.009-1.902.473-1.902.473l-.184-.307 5.608-9.587-3.777-2.603s-4.872 8.062-7.79 14.231-2.41 11.068-1.13 14.073c1.271 3.006 4.793 5.451 8.211 5.477s8.36-2.059 9.482-7.676c1.122-5.6-1.227-10.445-3.418-12.329zm-5.81 14.573c-2.086 0-3.777-2.401-3.777-5.354s1.691-5.354 3.777-5.354 3.777 2.401 3.777 5.354-1.7 5.354-3.777 5.354z",
    fill: "#e5007f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapanLoto6);
export default __webpack_public_path__ + "static/media/japan_loto_6.03683bd78de268e9fc6b0f7df54a2a06.svg";
export { ForwardRef as ReactComponent };